'use client';

import { builder } from '@builder.io/react';
import { withSuspense } from 'components/with-suspense';
import Link from 'next/link';
import { ContentRecs } from 'propel-react-components';
import { LinkComponentInterface } from 'propel-shared-utility';
import getContentRecsStackedStrategy from './contentRecsStackedStrategy';

const LinkComponent: LinkComponentInterface = ({ href, className, children, ...rest }) => {
    return (
        <Link href={href ?? '#'} className={className} {...rest}>
            {children}
        </Link>
    );
};

const ContentRecsSkeleton = (
    <div className="megamenu__recs">
        <div className="megamenu__recs-tile megamenu__recs-tile--4 animate-pulse"></div>
        <div className="megamenu__recs-tile megamenu__recs-tile--4 animate-pulse"></div>
        <div className="megamenu__recs-tile megamenu__recs-tile--4 animate-pulse"></div>
    </div>
);

export const ContentRecsStackedWrap = withSuspense(getContentRecsStackedStrategy(ContentRecs, builder.editingMode, LinkComponent), ContentRecsSkeleton)
